export default __webpack_public_path__ + "static/media/building-icon.png?.4f08d99b";